import React from "react";
import { Route, Routes } from "react-router-dom";

import NavBar from "./Componentes/NavBar/NavBar";

import Inicio from "./Componentes/Inicio/inicio";

import FormContainer from "./Componentes/Formulario/form-container.js";
import Footer from "./Componentes/Footer/Footer";

import "./App.css";
import Description from "./Componentes/Description/description.js";

function App() {
  return (
    <div className="App">
      <NavBar />

      <Routes>
        <Route exact path="/" element={<Inicio />} />
        <Route path="/description" element={<Description />} />

        <Route path="/contactarme" element={<FormContainer />} />
      </Routes>

      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default App;
